import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmTeacherIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmTeacherIcon = ({ className, ...props }: EmTeacherIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_262_44489)">
      <path
        d="M20.9085 1.87343H1.09302V15.1972H20.9085V1.87343Z"
        fill="url(#paint0_linear_262_44489)"
      />
      <path
        d="M20.503 2.27906V14.7933H1.49703V2.27906H20.503ZM21.3125 1.46953H0.6875V15.6028H21.3125V1.46953Z"
        fill="url(#paint1_linear_262_44489)"
      />
      <path
        d="M11 15.6028H9.36719V17.4642C9.36719 18.3064 10.0323 18.9887 10.8505 18.9887H11.1478C11.9677 18.9887 12.6311 18.3064 12.6311 17.4642V15.6028H11Z"
        fill="#EDC391"
      />
      <path
        d="M14.2141 16.708C13.53 16.5911 12.8184 16.5155 12.1 16.4777L11.6377 16.9744L11.0103 17.6499L10.3795 16.9727L9.91719 16.476C9.19875 16.5103 8.48719 16.5791 7.80141 16.6856C4.65094 17.1755 2.0625 18.4525 2.0625 20.7539V21.3091H2.32031H2.57812H19.4219H19.6797H19.9375V20.7539C19.9375 18.5814 17.368 17.2356 14.2141 16.708Z"
        fill="url(#paint2_linear_262_44489)"
      />
      <path
        d="M17.894 21.3091H3.96008C4.00649 20.2538 4.1818 18.9338 4.66133 17.5536C4.66133 17.5536 5.02055 17.3714 5.60321 17.1652C5.78368 17.0999 5.98649 17.0329 6.20649 16.9693C6.67055 16.8318 7.21368 16.7063 7.7929 16.6375L8.20711 19.1349L10.9004 17.7221H11.1187L13.812 19.1349L14.2262 16.6375C15.9604 16.8438 17.3577 17.5536 17.3577 17.5536C17.8373 18.9338 17.937 20.2538 17.894 21.3091Z"
        fill="url(#paint3_linear_262_44489)"
      />
      <path
        d="M6.20641 16.9693C5.73031 18.6502 5.50516 20.3844 5.46047 21.3091H4.94141C4.97922 20.4171 5.17516 18.798 5.60312 17.1652C5.78359 17.0999 5.98641 17.0328 6.20641 16.9693Z"
        fill="url(#paint4_linear_262_44489)"
      />
      <path
        d="M17.0587 21.3091C17.0192 20.3896 16.7889 18.81 16.3334 17.1325L15.7284 16.9435C16.232 18.6708 16.4932 20.3569 16.5396 21.3091H17.0587Z"
        fill="url(#paint5_linear_262_44489)"
      />
      <path
        d="M12.7376 15.7919L12.0999 16.4777L11.8713 16.7235L11.6376 16.9744L11.0102 17.6499L10.3794 16.9727L10.1474 16.7235L9.9171 16.476L9.28116 15.7919L7.79272 16.6375L7.80132 16.6857L7.84429 16.9452L7.88554 17.1961L8.20694 19.1349L11.0102 17.6653L13.8118 19.1349L14.1298 17.2167L14.1727 16.9607L14.214 16.708L14.226 16.6375L12.7376 15.7919Z"
        fill="url(#paint6_linear_262_44489)"
      />
      <path
        d="M17.3559 21.3091L17.4899 20.845L17.5982 20.4703L17.5879 20.4669L17.5896 20.4583L17.3232 20.3827L17.6051 19.3995C17.6223 19.3394 17.6205 19.2792 17.6051 19.2242C17.6051 19.2225 17.6034 19.2191 17.6034 19.2174C17.6016 19.2105 17.5999 19.2053 17.5965 19.2002C17.5673 19.1074 17.5002 19.0334 17.4091 19.0059L17.3834 18.9991C17.3834 18.9991 17.3834 18.9991 17.3816 18.9991L16.7371 18.8134L10.7318 17.0878C10.7232 17.0861 10.7163 17.0861 10.7094 17.0827C10.1526 16.9366 9.57851 17.2597 9.41867 17.8166L9.17117 18.6811C9.15398 18.7395 9.13507 18.8031 9.11445 18.8719L8.88757 19.6642L8.41492 21.3108L17.3559 21.3091Z"
        fill="url(#paint7_linear_262_44489)"
      />
      <path
        d="M17.5794 21.3091L18.1758 19.2277C18.2256 19.0541 18.1259 18.8736 17.9523 18.8255L11.3025 16.9177C10.7388 16.7561 10.1492 17.0827 9.98766 17.6464L8.9375 21.3091H17.5794Z"
        fill="#424242"
      />
      <path
        d="M17.8785 21.3091L18.0607 20.6766C18.1209 20.4669 17.9954 20.2469 17.7823 20.1867L10.646 18.1414C9.86746 17.918 9.73167 18.5453 9.51339 19.3067L8.93933 21.3091H17.8785Z"
        fill="url(#paint8_linear_262_44489)"
      />
      <g opacity="0.2">
        <path
          d="M11.0568 17.4574C11.0877 17.4574 11.1221 17.4608 11.1582 17.4694L17.5605 19.3085L17.5072 19.4941C15.4808 18.9286 11.6136 17.8407 10.8144 17.576C10.8557 17.5192 10.9364 17.4574 11.0568 17.4574ZM11.0568 16.885C10.2799 16.885 9.89144 17.8424 10.5205 18.0778C11.2132 18.3357 17.8991 20.1953 17.8991 20.1953L18.1707 19.2466C18.2239 19.0644 18.138 18.8788 17.9799 18.8341L11.3042 16.916C11.2183 16.8953 11.1358 16.885 11.0568 16.885Z"
          fill="#424242"
        />
      </g>
      <path
        d="M17.7667 19.2706L10.9261 17.3078C10.7404 17.2545 10.5376 17.3869 10.4757 17.6017L10.4654 17.6395C10.4036 17.8544 10.505 18.0744 10.6906 18.1277L17.5312 20.0905C17.5312 20.0905 17.4728 19.9478 17.5432 19.6952C17.6137 19.4408 17.7667 19.2706 17.7667 19.2706Z"
        fill="url(#paint9_linear_262_44489)"
      />
      <mask
        height="4"
        id="mask0_262_44489"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        width="11"
        x="8"
        y="18"
      >
        <path
          d="M18.162 20.2864L10.5136 18.1105C9.90686 17.9386 9.84326 18.1483 9.68686 18.7L8.94092 21.3091H18.2479L18.162 20.2864Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_262_44489)">
        <path
          d="M9.60274 21.3091L10.9365 16.6633L9.83134 16.3453L8.40649 21.3091H9.60274Z"
          fill="url(#paint10_linear_262_44489)"
        />
      </g>
      <path
        d="M15.6971 8.66766H14.4304H7.56917H6.30245C5.29011 8.66766 4.46167 9.5511 4.46167 10.6288C4.46167 11.7064 5.29011 12.5899 6.30245 12.5899H7.56917H14.4287H15.6954C16.7078 12.5899 17.5362 11.7064 17.5362 10.6288C17.5362 9.5511 16.7095 8.66766 15.6971 8.66766Z"
        fill="#EDC391"
      />
      <path
        d="M10.9998 1.90265C8.00915 1.90265 5.23853 5.10124 5.23853 9.70577C5.23853 14.2845 8.09337 16.5481 10.9998 16.5481C13.9062 16.5481 16.761 14.2828 16.761 9.70405C16.761 5.10124 13.9904 1.90265 10.9998 1.90265Z"
        fill="#F9DDBD"
      />
      <path
        d="M8.2824 10.9845C8.75038 10.9845 9.12975 10.5921 9.12975 10.108C9.12975 9.62385 8.75038 9.2314 8.2824 9.2314C7.81443 9.2314 7.43506 9.62385 7.43506 10.108C7.43506 10.5921 7.81443 10.9845 8.2824 10.9845Z"
        fill="#312D2D"
      />
      <path
        d="M13.6348 10.9845C14.1028 10.9845 14.4822 10.5921 14.4822 10.108C14.4822 9.62387 14.1028 9.23141 13.6348 9.23141C13.1668 9.23141 12.7875 9.62387 12.7875 10.108C12.7875 10.5921 13.1668 10.9845 13.6348 10.9845Z"
        fill="#312D2D"
      />
      <path
        d="M11.6633 11.6978C11.6444 11.6909 11.6272 11.6858 11.6083 11.6841H10.3914C10.3725 11.6858 10.3536 11.6909 10.3364 11.6978C10.2264 11.7425 10.1662 11.8559 10.2178 11.978C10.2694 12.1 10.5117 12.4403 10.9998 12.4403C11.4879 12.4403 11.7303 12.0983 11.7819 11.978C11.8334 11.8559 11.7733 11.7425 11.6633 11.6978Z"
        fill="#DBA689"
      />
      <path
        d="M12.4659 13.0866C11.9193 13.4114 10.1233 13.4114 9.57669 13.0866C9.26216 12.8992 8.94075 13.1862 9.07138 13.4716C9.20028 13.7517 10.1783 14.4031 11.0256 14.4031C11.8729 14.4031 12.8389 13.7517 12.9678 13.4716C13.0967 13.1862 12.7804 12.8992 12.4659 13.0866Z"
        fill="#444444"
      />
      <path
        d="M6.87641 8.71748C7.39032 7.99045 8.55735 7.9217 9.22594 8.46311C9.3325 8.54905 9.47344 8.66936 9.51469 8.80342C9.58344 9.0217 9.37375 9.19186 9.16922 9.1403C9.0386 9.10764 8.91657 9.03717 8.78766 8.99764C8.55219 8.92373 8.38203 8.90311 8.17063 8.90311C7.85782 8.90139 7.65672 8.94092 7.35938 9.06123C7.23735 9.11108 7.13766 9.19014 6.99844 9.1317C6.8386 9.06639 6.77844 8.86186 6.87641 8.71748Z"
        fill="#454140"
      />
      <path
        d="M14.793 9.13173C14.7431 9.10938 14.695 9.08188 14.6452 9.06126C14.3392 8.93407 14.1656 8.90141 13.8339 8.90313C13.5417 8.90485 13.3681 8.94438 13.1395 9.02173C13.0003 9.06985 12.8233 9.19016 12.6686 9.14376C12.4417 9.07501 12.4486 8.82751 12.5723 8.66938C12.7202 8.48376 12.923 8.34282 13.1378 8.25001C13.6362 8.03345 14.2447 8.06438 14.7139 8.34454C14.8669 8.43563 15.0336 8.5611 15.1264 8.71923C15.2605 8.94266 15.0577 9.24001 14.793 9.13173Z"
        fill="#454140"
      />
      <path
        d="M11.0003 0.692657C10.9985 0.692657 10.9985 0.692657 10.9968 0.692657C10.9951 0.692657 10.9951 0.692657 10.9934 0.692657C3.1851 0.733907 4.78526 9.65422 4.78526 9.65422C4.78526 9.65422 5.13588 10.5738 5.29573 10.9794C5.31807 11.0378 5.40401 11.0309 5.41776 10.9708C5.58448 10.2248 6.18432 7.57969 6.48682 6.77531C6.66557 6.30094 7.15713 6.02594 7.65385 6.11703C8.41869 6.25625 9.63901 6.42813 10.9831 6.42813C10.9882 6.42813 10.9934 6.42813 10.9968 6.42813C11.0003 6.42813 11.0071 6.42813 11.0106 6.42813C12.3546 6.42813 13.5749 6.25625 14.3398 6.11703C14.8382 6.02594 15.3298 6.30266 15.5068 6.77531C15.8076 7.57625 16.404 10.2059 16.5724 10.9622C16.5862 11.0241 16.6721 11.0292 16.6945 10.9708L17.2067 9.6525C17.2101 9.65422 18.8103 0.733907 11.0003 0.692657Z"
        fill="#312D2D"
      />
      <path
        d="M17.2099 9.65422C17.2099 9.65422 18.8101 0.733907 11.0001 0.692657C10.9983 0.692657 10.9983 0.692657 10.9966 0.692657C10.9949 0.692657 10.9949 0.692657 10.9932 0.692657C10.8711 0.692657 10.7526 0.696095 10.6357 0.701251C10.4037 0.711564 10.1785 0.728751 9.96193 0.754532C9.96021 0.754532 9.95677 0.754532 9.95506 0.754532C9.93959 0.756251 9.92584 0.759689 9.91037 0.761407C3.33787 1.58813 4.78506 9.65422 4.78506 9.65422L5.29724 10.9742C5.31959 11.0327 5.40381 11.0275 5.41756 10.9656C5.58599 10.2111 6.18412 7.57797 6.48662 6.77703C6.66537 6.30266 7.15693 6.02766 7.65365 6.11875C8.41849 6.25797 9.63881 6.42985 10.9829 6.42985C10.988 6.42985 10.9932 6.42985 10.9966 6.42985C11.0001 6.42985 11.0069 6.42985 11.0104 6.42985C12.3544 6.42985 13.5747 6.25797 14.3396 6.11875C14.838 6.02766 15.3296 6.30438 15.5066 6.77703C15.8091 7.58141 16.409 10.2317 16.574 10.9742C16.5877 11.0361 16.6719 11.0413 16.6943 10.9828C16.8576 10.5772 17.2099 9.65422 17.2099 9.65422Z"
        fill="url(#paint11_radial_262_44489)"
      />
      <path
        d="M16.1443 9.09733C16.1322 8.8928 16.1236 8.87218 15.8538 8.78624C15.6424 8.71921 14.4874 8.62468 13.6177 8.6728C13.5558 8.67624 13.4957 8.67968 13.4389 8.68483C12.65 8.75186 11.703 9.06983 10.9914 9.08702C10.6889 9.0939 9.44285 8.76733 8.56113 8.69858C8.50441 8.69515 8.44769 8.68999 8.38926 8.68827C7.51785 8.64358 6.35769 8.74499 6.14629 8.81374C5.87644 8.9014 5.86785 8.92202 5.85754 9.12655C5.84551 9.32936 5.87988 9.50468 6.03972 9.55796C6.25801 9.63015 6.25972 9.90171 6.40582 10.682C6.53816 11.3936 6.85613 11.9556 8.22254 12.0536C8.28097 12.057 8.33597 12.0605 8.39097 12.0605C9.59926 12.0776 10.0152 11.2819 10.1527 11.0172C10.4088 10.5256 10.328 9.84843 11.0052 9.84671C11.6807 9.84499 11.6171 10.5101 11.8766 11C12.0158 11.263 12.4214 12.0622 13.6194 12.045C13.6778 12.045 13.738 12.0416 13.7999 12.0364C15.1646 11.9298 15.4808 11.3661 15.608 10.6545C15.7489 9.87249 15.7507 9.59921 15.9672 9.52702C16.1236 9.47546 16.1563 9.30186 16.1443 9.09733ZM9.17301 11.7167C8.96332 11.8147 8.68316 11.8645 8.38754 11.8645C7.77051 11.8628 7.08644 11.6462 6.83894 11.2097C6.48832 10.5875 6.39722 9.32936 6.8441 9.0664C7.04004 8.95124 7.70176 8.87218 8.38582 8.9014C9.09566 8.93233 9.82957 9.08015 10.0943 9.42733C10.5343 9.99968 9.83644 11.4039 9.17301 11.7167ZM15.1714 11.1839C14.9257 11.6239 14.2364 11.8456 13.616 11.8473C13.3238 11.8491 13.0471 11.8009 12.8408 11.7047C12.1757 11.3953 11.471 9.99624 11.9041 9.42046C12.1671 9.06983 12.9044 8.91858 13.616 8.88421C14.2983 8.85155 14.9583 8.92718 15.1525 9.04061C15.6028 9.30186 15.5186 10.56 15.1714 11.1839Z"
        fill="#212121"
        stroke="#212121"
        strokeMiterlimit="10"
        strokeWidth="0.504075"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_262_44489"
        x1="10.9998"
        x2="10.9998"
        y1="1.95856"
        y2="15.2091"
      >
        <stop stopColor="#26A69A" />
        <stop
          offset="1"
          stopColor="#00796B"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_262_44489"
        x1="10.9999"
        x2="10.9999"
        y1="1.46867"
        y2="15.6021"
      >
        <stop stopColor="#8D6E63" />
        <stop
          offset="0.7789"
          stopColor="#795548"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_262_44489"
        x1="11"
        x2="11"
        y1="16.513"
        y2="21.1177"
      >
        <stop stopColor="#E1F5FE" />
        <stop
          offset="1"
          stopColor="#81D4FA"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_262_44489"
        x1="10.9315"
        x2="10.9315"
        y1="16.6375"
        y2="21.1703"
      >
        <stop stopColor="#00BFA5" />
        <stop
          offset="1"
          stopColor="#00AB94"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_262_44489"
        x1="5.57391"
        x2="5.57391"
        y1="16.3696"
        y2="21.1489"
      >
        <stop
          stopColor="#B2DFDB"
          stopOpacity="0.2"
        />
        <stop
          offset="0.7674"
          stopColor="#B2DFDB"
          stopOpacity="0.6"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_262_44489"
        x1="16.3941"
        x2="16.3941"
        y1="16.3403"
        y2="21.1484"
      >
        <stop
          stopColor="#B2DFDB"
          stopOpacity="0.2"
        />
        <stop
          offset="0.7674"
          stopColor="#B2DFDB"
          stopOpacity="0.6"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_262_44489"
        x1="11.0094"
        x2="11.0094"
        y1="19.8865"
        y2="15.9528"
      >
        <stop stopColor="#E1F5FE" />
        <stop
          offset="1"
          stopColor="#81D4FA"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_262_44489"
        x1="13.6037"
        x2="12.5152"
        y1="18.3705"
        y2="22.9538"
      >
        <stop
          offset="0.0017"
          stopColor="#212121"
          stopOpacity="0.2"
        />
        <stop
          offset="1"
          stopColor="#212121"
          stopOpacity="0.6"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint8_linear_262_44489"
        x1="14.0746"
        x2="13.1866"
        y1="19.0336"
        y2="22.0128"
      >
        <stop stopColor="#EF5350" />
        <stop
          offset="1"
          stopColor="#E53935"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_262_44489"
        x1="10.4711"
        x2="17.6485"
        y1="17.6203"
        y2="19.68"
      >
        <stop
          offset="0.0102"
          stopColor="#BDBDBD"
        />
        <stop
          offset="0.9869"
          stopColor="#F5F5F5"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_262_44489"
        x1="9.03305"
        x2="9.785"
        y1="20.9767"
        y2="18.6134"
      >
        <stop stopColor="#212121" />
        <stop
          offset="1"
          stopColor="#424242"
        />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(10.9972 8.09493) scale(6.54715 7.38649)"
        gradientUnits="userSpaceOnUse"
        id="paint11_radial_262_44489"
        r="1"
      >
        <stop
          offset="0.7945"
          stopColor="#454140"
          stopOpacity="0"
        />
        <stop
          offset="1"
          stopColor="#454140"
        />
      </radialGradient>
      <clipPath id="clip0_262_44489">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmTeacherIcon;
